import React from 'react';
import { Row, Col, Pagination } from 'react-bootstrap';
import { Button } from "../../../components/buttons";
import { liveStatus, endStatus, preStatus } from "../constants";

const SubStatus = props => {
    let statusList;
    switch (props.tab) {
        case 'notActive':
            statusList = endStatus;
            break;
        case 'active':
            statusList = liveStatus;
            break;
        case 'preActive':
            statusList = preStatus;
            break;
        case 'pending':
            statusList = [{ name:'Semua', value:props.tab}];
            break;
    };

    return (
        <div className="border-bottom">
            <Row>
                <Col style={{paddingRight:0}}>
                    <div style={{display:'flex',overflowX:'auto'}}>
                    {
                        statusList.map((i,idx) => {
                            let titleText;
                            if (props.statusValues[i.value]) {
                                titleText = i.name + " (" + props.statusValues[i.value] + ")"
                            } else {
                                titleText = i.name
                            }
                            
                            return (
                                <div key={idx}>
                                    <div
                                        onClick={() => props.onClick(i.value)}
                                        style={{
                                            minWidth:'80%',
                                            borderRadius:32,
                                            backgroundColor:props.status === i.value ? '#CCF1ED' : null
                                        }} 
                                        className={`px-4 border m-2 pointer ${props.status === i.value ? ' border-primary' : null}`}
                                    >
                                        <div 
                                            style={{
                                                whiteSpace:'nowrap',
                                                overflow:'hidden',
                                                color:props.status === i.value ? '#007266' : null,
                                                borderColor:props.status === i.value ? '#007266' : null
                                            }}
                                            className={`text-small ${props.status === i.value ? 'strong' : null}`}>
                                            {props.status === i.value ? <b>{titleText}</b> : titleText}
                                        </div>
                                    </div>
                                </div>
                            )
                            
                        })
                    }
                    </div>
                </Col>
            </Row>
        </div>
    )
};

export default SubStatus;

